var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"section-top"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.showTips)?_c('div',{staticClass:"tips"},[_vm._v("数据来自咪咕，延迟1小时左右更新")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }